import React from 'react';
import './MainContent.css';

// Komponent do stylowania obszaru treści
function MainContent({ children }) {
  return (
    <main className="main-content">
      <div className="main-content__container">{children}</div>
    </main>
  );
}
export default MainContent;
